import { FormProvider } from "react-hook-form";
import { Color, MagnifyingGlassIcon, TextFieldController } from "@bonliva-crm/ui";
import { Box, Divider, Typography, makeStyles } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { useBookingKitSearchFilters } from "./hooks/use-booking-kit-search-filters";
import { SearchProfileType } from "@bonliva-crm/graphql";
import { FilterSlider } from "@bonliva-crm/ui/search-filters";
import { FavouriteFilter } from "@bonliva-crm/ui/search-filters";
import { BookingKitTable } from "./components/kits-table/booking-kit-table";

export const BookingKitSearchLayout = () => {
  const classes = useStyles();

  const { filterManager } = useBookingKitSearchFilters();

  return (
    <FormProvider {...filterManager.formMethods}>
      <Box className={classes.root}>
        <Box className={classes.flexColumn}>
          <Box className={classes.flexRow} style={{ justifyContent: "space-between" }}>
            <Typography variant="h2">{locale.mainMenu.kitFlow}</Typography>
            <TextFieldController
              name="text"
              textFieldProps={{
                className: classes.searchField,
                placeholder: locale.Search,
                inputProps: { autoComplete: "off" },
                InputProps: {
                  startAdornment: <MagnifyingGlassIcon />,
                  style: { borderColor: Color.DarkGray }
                }
              }}
            />
          </Box>
          <FavouriteFilter
            filterManager={filterManager}
            searchProfileType={SearchProfileType.Kits}
          />
          <Divider />
          <BookingKitTable />
        </Box>
        <FilterSlider
          sortByLabel
          filterManager={filterManager}
          searchProfileType={SearchProfileType.Kits}
        />
      </Box>
    </FormProvider>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2, 4, 5.2, 2),
    height: "100%"
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    height: "100%"
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(2)
  },
  searchField: {
    width: "80%"
  },
  allFilters: {
    padding: "0 1rem",
    border: `1px solid ${Color.LightGray}`,
    height: "2.5rem",
    borderRadius: "0.375rem",
    width: "125px",
    "&:hover": {
      cursor: "pointer"
    }
  }
}));
